import "./DeleteModal.css";

function DeleteModal({
  isOpen,
  onClose,
  onConfirm,
  loading,
  title,
  message,
}) {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">

      <div className="delete-modal">

        <h2>{title}</h2>

        <p>{message}</p>

        <div className="delete-actions">

          <button
            className="cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="delete-btn"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>

        </div>

      </div>

    </div>
  );
}

export default DeleteModal;